module.exports = __webpack_public_path__ + "img/img_index_cha_01_1@2x.52d7ad32.png";